import React, { PureComponent } from 'react';
import { Toast, ImagePicker } from 'antd-mobile/lib';

import CertificationCard from './CertificationCard.js';
import { connect } from 'react-redux';
import { getTempInfo, getStorage } from '../../common.js';
import { hashHistory } from 'react-router';
import Util from '../../util';
import { returnDate } from '../../util';
import { 
	uploadCertificatePic,
	getConversationIds,
	saveUserAccount
} from '../../action/myAssets/userInfoAction.js';
import NavigatorMain from '../NavigatorMain.js';
import { zzhZjyxq } from "../../action/investmentAction"

class CertificationUpload extends PureComponent {
	state = {
		isRealName: false,
		filesList:[{url: ""}, {url: ""}]
	}

	componentWillUnmount() {
		
	}

	componentWillMount() {
		
	}

	async componentDidMount() {
		let isRealName = await getStorage('loginState');
		console.log(isRealName, this.props.location.state)
		if(isRealName == "2") {
			this.setState({
				isRealName: true
			});
		}
	}

	getConversationIDFun = () => {
		this.props.dispatch(getConversationIds({}, (res) => {
			console.log(res);
			if(this.state.isRealName) {
				this.goCertSec(res.content.zzh);
			}else {
				this.goCert(res.content.zzh, res.content.kzr, res.content.syr);
			}
		}, () => {

		}));
	}

	saveUserAccountFun = (token, allParams, kzrId, syrId) => {
		let isTrueKzr = allParams.certNo != allParams.actualControllerCertNo ? true : false;
		let isTrueSyr = allParams.certNo != allParams.actualBeneficiaryCertNo ? true : false;
		if(isTrueKzr || isTrueSyr) {
			// let _actualControllerValidTerm = allParams.actualControllerValidTerm=="长期有效"?"":allParams.actualControllerValidTerm+" 00:00:00";
			// let _actualBeneficiaryValidTerm = allParams.actualBeneficiaryValidTerm=="长期有效"?"":allParams.actualBeneficiaryValidTerm+" 00:00:00";
			this.props.dispatch(saveUserAccount({
				actualController: isTrueKzr ? allParams.actualController : "",
				actualControllerCertNo: isTrueKzr ? allParams.actualControllerCertNo : "",
				actualControllerCertType: isTrueKzr ? allParams.actualControllerCertType : "",
				actualControllerValidTerm: isTrueKzr ? allParams.actualControllerValidTerm : "" ,
				actualControllerValidEver: isTrueKzr ? allParams.actualControllerValidEver : "",
				controllerConversationId: isTrueKzr ? kzrId : "",
				actualBeneficiary: isTrueSyr ? allParams.actualBeneficiary : "",
				actualBeneficiaryCertNo: isTrueSyr ? allParams.actualBeneficiaryCertNo : "",
				actualBeneficiaryCertType: isTrueSyr ? allParams.actualBeneficiaryCertType : "",
				actualBeneficiaryValidTerm: isTrueSyr ? allParams.actualBeneficiaryValidTerm : "",
				actualBeneficiaryValidEver: isTrueSyr ? allParams.actualBeneficiaryValidEver : "",
				beneficiaryConversationId: isTrueSyr ? syrId : "",
				token: token
			}));
		}
	}

	savePic = (files, requestId, token, zzhId, kzrId, syrId, allParams) => {
		const { dispatch } = this.props;
		let formData = new FormData();
	    for(let i = 0; i < files.length; i++) {
	        formData.append("multipartFiles", files[i].file);
	    }
	    formData.append("clientType", Util.return_Clinet_Type());
	    formData.append("token", token);
	    formData.append("requestId", requestId);
		formData.append("conversationId", zzhId);
		formData.append("fillAccountNo", true);
	    dispatch(uploadCertificatePic(formData, (result) => {

	    }, () =>{

	    }, true,"0"));
		this.saveUserAccountFun(token, allParams, kzrId, syrId);
	}
	
	goBack = () => {
		hashHistory.goBack();
	}

	resetFun = () => {
		this.setState({
			filesList:[{url: ""}, {url: ""}]
		});
	}

	goCert = (zzhId, kzrId, syrId) => {
		const { dispatch } = this.props;
		const callback = this.props.location.state && this.props.location.state.callback ? this.props.location.state.callback : null;
		const route = this.props.location.state && this.props.location.state.route ? this.props.location.state.route : null;
		const backFun = this.props.location.state && this.props.location.state.backFun ? this.props.location.state.backFun : null;
		const phoneNo = this.props.location.state && this.props.location.state.phoneNo ? this.props.location.state.phoneNo : null;
		const { filesList } = this.state;
		let formData = new FormData();
		Toast.loading("正在加载");
		getTempInfo( 'shortToken' )
		.then((token) => { 
			for(let i = 0; i < filesList.length; i++) {
				formData.append("multipartFiles", filesList[i].file);
			}
			formData.append("clientType", Util.return_Clinet_Type());
			formData.append("token", token);
			formData.append("conversationId", zzhId); 
			formData.append("mobileNo", this.props.location.state.phoneNo); 
			dispatch(uploadCertificatePic(formData, (result) => {
				console.log(result)
				Toast.hide();
				let objzzh ={
					certValidTerm: result.content.certificateValidEver?"长期有效":returnDate(result.content.certificateValidTerm),
					certValidEver: result.content.certificateValidEver?"1":"0",
				}
				dispatch(zzhZjyxq(objzzh));
				let reg = /^[1-9]\d{3}.(0[1-9]|1[0-2]).(0[1-9]|[1-2][0-9]|3[0-1])$/
				if(!reg.test(result.content.validity.split("-")[0])){
					Toast.info( "身份信息识别失败，请重新上传本人证件照片，拍照时请确保证件边框完成、图像清晰、光线均匀。", 2);
					this.resetFun();
				}else{
					if(result.content.validity.split("-")[1]=="长期" || reg.test(result.content.validity.split("-")[1])){
						hashHistory.push({
							pathname:'/CertificationCard',
							state: {
								personNo: result.content.certificateNo,
								realName: result.content.certificateName,
								conversationId: zzhId,
								kzrId: kzrId,
								syrId: syrId,
								certificateValidEver: result.content.certificateValidEver,
								certificateValidTerm: result.content.certificateValidTerm,
								validity: result.content.validity,
								mobileNo: this.props.location.state.phoneNo,
								resetFun: () => {
									this.resetFun();
								},
								route: route ? route : null,
								callback: callback ? callback : null,
								phoneNo: phoneNo ? phoneNo : null,
								backFun: backFun ? backFun : null,
								savePicFun: (token, allParams) => {
									this.savePic(filesList, result.content.requestId, token, zzhId, kzrId, syrId, allParams);
								},
								BoolVule: true
							},
							query: {enterType:this.state.enterType,
								activityId:this.props.location.query.activityId
							}
						});
					}else{
						Toast.info( "身份信息识别失败，请重新上传本人证件照片，拍照时请确保证件边框完成、图像清晰、光线均匀。", 2);
						this.resetFun();
					}
				}
			}, () => {
				Toast.hide();
			}, false,"0"))
		})
		.catch((err) => {
			Toast.hide();
		});		
	}

	goCertSec = (zzhId) => {
		const { dispatch } = this.props;
		const callback = this.props.location.state && this.props.location.state.callback ? this.props.location.state.callback : null;
		const { filesList } = this.state;
		let formData = new FormData();
		Toast.loading("正在加载");
		getTempInfo( 'shortToken' )
		.then((token) => { 
			for(let i = 0; i < filesList.length; i++) {
				formData.append("multipartFiles", filesList[i].file);
			}
			formData.append("clientType", Util.return_Clinet_Type());
			formData.append("token", token);
			formData.append("conversationId", zzhId);
			dispatch(uploadCertificatePic(formData, (result) => {
				formData.append("requestId", result.content.requestId);
				formData.append("conversationId", zzhId);
				dispatch(uploadCertificatePic(formData, (_result) => {
					Toast.hide();
					Toast.info( '身份证上传成功', 2000, () => {
						this.goBack();
						if(callback) {
							setTimeout(() => {
								callback();
							});
						}
					});
				}, () => {
					Toast.hide();
				}, true,"0"));
			}, () => {
				Toast.hide();
			}, false,"0"))
		})
		.catch((err) => {
			Toast.hide();
		});		
	}

	onChangeImg = (files, index) => {
		Util.compressPicture(files).then((res)=>{
			const newArr = [].concat(this.state.filesList);
	    newArr[index] = res;
	    this.setState({
	      filesList: newArr
	    });
		}).catch(()=>{
			Toast.fail('请正确上传本人有效证件',Util.ToastTime)
		})
	    
	}

	render() {
		const { isRealName, filesList } = this.state;
        console.log(filesList,"8383838383",isRealName)
		return (
			<div className="mainBox"> 
		        <NavigatorMain>
		          <div className="boxHeader">
		            <div>
		              <img onClick={this.goBack} src={require("../../img/leftArrow_header.png")} />
		            </div>
		            <div>
		              <span>实名认证</span>
		            </div>
		            <div>
		              
		            </div>
		          </div>
		        </NavigatorMain> 
				<div className="boxContent">
					<div style={{paddingLeft: 13, paddingRight: 13, height: 76, backgroundColor: "#fff", display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center"}}>
						<div style={{fontSize: 13, color: "#535760", lineHeight: "20px"}}>请上传本人身份证照片，拍照时请确保身份证边框完整、图像清晰、光线均匀：</div>
					</div>
					<div style={{paddingTop: 30, paddingBottom: 30, display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center"}}>
						<div style={{fontSize: 18, color: "#33363F"}}>请拍摄/上传您的二代身份证</div>
					</div>
					<div style={{paddingLeft: 13, paddingRight: 13}}>
						{
							filesList.map((data, index) => {
								return (
									<div id="uploadCert" key={index} style={{backgroundColor: "#fff", height: 204, display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center", width: "100%", marginTop: index == "0" ? 0 : 10}}>
										{
											data.url ? 
											<div style={{position: "relative", width: 270, height: 150}}>
												<img
												src = {data.url}
												style={{width: "100%", height: "100%"}}
												/>
												<ImagePicker
												style={{opacity: 0,position: "absolute", left: 90, top: 15,width:"100%",height:"100%"}}
									            files={[]}
									            length={1}
									            selectable={true}
									            disableDelete={true}
									            onChange={(files) => {this.onChangeImg(files, index)}}
									            multiple={false}
									            />
											</div>
											:
											<div style={{borderColor: "#000", borderStyle: "dotted", borderRadius: 0.5, borderWidth: 1, width: 270, height: 150}}>
												{
													
													<div style={{position: "relative", width: 262, height: 144, display: "-webkit-flex", backgroundImage: index == "0" ? `url(${require("../../img/ID Card front_.png")})` : `url(${require("../../img/ID Card back_.png")})`}}>
														<div style={{WebkitFlexDirection: "column", display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center", WebkitFlex: 1}}>
															<div style={{width: 60, height: 60, display: "-webkit-flex", borderRadius: 60, backgroundColor: "#3691FF", WebkitJustifyContent: "center", WebkitAlignItems: "center"}}>
																<img src={require("../../img/camera_.png")} style={{width: 35, height: 30}} />
															</div>
															<div style={{color: "#535760", fontSize: 15, marginTop: 10}}>{index == "0" ? "点击拍摄/上传人像面" : "点击拍摄/上传国徽面"}</div>
														</div>
														<ImagePicker
														style={{ opacity: 0,position: "absolute", left: 90, top: 15,width:"100%",height:"100%"}}
											            files={[]}
											            length={1}
											            selectable={true}
											            disableDelete={true}
											            onChange={(files) => {this.onChangeImg(files, index)}}
											            multiple={false}
											            />
													</div>
												}
											</div>	
										}
									</div>
								)
							})
						}
					</div>
					{
						filesList[0].url == "" || filesList[1].url == "" ?
						<div style={styles.disableBtnSuccess}
						onClick={() => {}}
						>
							<div style={{color: "#fff", fontSize: 15}}>提交身份证照片</div>
						</div>
						:
						<div style={styles.btnSuccess}
						onClick={this.getConversationIDFun}
						>
							<div style={{color: "#fff", fontSize: 15}}>提交身份证照片</div>
						</div>
					}
				</div>
			</div>
		)
	}
}

export default connect(mapStateToProps)(CertificationUpload);

const styles = {
	disableBtnSuccess: {
		marginTop: 30,
		height: 40,
		backgroundColor: "#afb0b2",
		WebkitJustifyContent: "center",
		WebkitAlignItems: "center",
		marginLeft: 13,
		marginRight: 13,
		marginBottom: 74,
		borderRadius: 30,
		display: "-webkit-flex"
	},
	btnSuccess: {
		marginTop: 30,
		height: 40,
		backgroundColor: "#FA063A",
		WebkitJustifyContent: "center",
		display: "-webkit-flex",
		WebkitAlignItems: "center",
		marginLeft: 13,
		marginRight: 13,
		marginBottom: 74,
		borderRadius: 30
	}
};

function mapStateToProps(state,ownProps) {
  return {
    
  }
}



// WEBPACK FOOTER //
// ./src/components/recommend/CertificationUpload.js